import LocaleContext from "./ak-locale-context";

export { LocaleContext };
export default LocaleContext;
